import {enDash} from "../common/constant";
import {dateToUTCTimezone} from "../common/date";
import moment from "moment";

export const getFormatOptions = (dateFrom, dateTo, shouldHideWeekday) => {
    const formatOptions = {};

    formatOptions.from = {weekday: !shouldHideWeekday ? "short" : undefined, day: "numeric"};
    if(dateFrom && dateTo) {
        if (!moment(dateFrom).isSame(dateTo, "month")) {
            formatOptions.from.month = "short";
        }
        if (!moment(dateFrom).isSame(dateTo, "year")) {
            formatOptions.from.year = "numeric";
        }
    } else {
        formatOptions.from.month = "short";
        formatOptions.from.year = "numeric";
    }

    formatOptions.to = {weekday: !shouldHideWeekday ? "short" : undefined, day: "numeric", month: "short", year: "numeric"};

    return formatOptions;
};

export const getDatesFromToLabel = (start, end, emptyLabel, formatDate, shouldHideWeekday) => {
    const dateFrom = paramToDate(start);
    const dateTo = paramToDate(end);
    const formatOptions = getFormatOptions(dateFrom, dateTo, shouldHideWeekday);
    let label = emptyLabel;

    if(formatDate) {
        if (dateFrom){
            label = formatDate(dateFrom, formatOptions?.from);
        }

        if (dateTo){
            if (dateFrom) {
                label += " " + enDash + " ";
            }
            label += formatDate(dateTo, formatOptions?.to);
        }
    }

    return label;
};

export const getDateLabel = (dateParam, emptyLabel, formatDate, formatOptions = {weekday: "short", day: "numeric", month: "short", year: "numeric"}) => {
    const dt = paramToDate(dateParam);
    let label = emptyLabel;
    if (dt && formatDate) {
        label = formatDate(dt, formatOptions);
    }
    return label;
};

const paramToDate = (param) => {
    if (param) {
        if (param instanceof moment) {
            return param.toDate();
        }
        if ((typeof param).toLowerCase() === "string") {
            return dateToUTCTimezone(param);
        } else {
            return param;
        }
    }
};
